import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterLink, ButtonModule],
  template: `
    <main class="page-shell">
      <section class="panel">
        <h1>Not found</h1>
        <p class="muted">The requested admin route does not exist.</p>
        <p-button label="Go to dashboard" severity="secondary" [outlined]="true" routerLink="/dashboard" />
      </section>
    </main>
  `,
})
export class NotFoundComponent {}
